import { Tooltip } from "primereact/tooltip";
import { DURACAO_LABELS, INFO_EMBARCACAO } from "../../nova-obra.constants";
import { formatDataBr } from "../format-data";
import styles from "./info-limites-classe.module.scss";
import type {
  InfoLimitesClasseProps,
  InfoLimitesClasseViewModel,
} from "./types-info-limites-classe";

/** Card de contexto da etapa Duração (Figma `info-embarcacao`, momentos Sem/Com período). */
export function InfoLimitesClasseView(props: InfoLimitesClasseProps & InfoLimitesClasseViewModel) {
  const { periodoObra, limites, compacto, visiveis, ocultos, info, onVerTodos } = props;

  return (
    <section className={styles.card} data-testid="info-limites-classe">
      <div className={styles.dates}>
        {periodoObra && (
          <>
            <span className={styles.item}>
              <strong>{DURACAO_LABELS.obra}</strong>
              {formatDataBr(periodoObra.inicio)} → {formatDataBr(periodoObra.fim)}
            </span>
            <span className={styles.divider} aria-hidden />
          </>
        )}
        <span className={styles.item}>
          <strong>{INFO_EMBARCACAO.terminoContrato}</strong>
          {formatDataBr(info.terminoContrato)}
        </span>
        <span className={styles.divider} aria-hidden />
        <span className={styles.item}>
          <strong>{INFO_EMBARCACAO.previsaoExtensao}</strong>
          {formatDataBr(info.previsaoExtensaoContratual)}
        </span>
      </div>

      {limites.length > 0 && (
        <div className={`${styles.limites} ${compacto ? styles.limitesCompacto : ""}`}>
          <strong className={styles.item}>{INFO_EMBARCACAO.limitesClasse}</strong>
          <div className={styles.tags}>
            {visiveis.map((limite) => (
              <span
                key={limite.chave}
                className={`${styles.tag} ${styles[limite.severidade]}`}
                data-pr-tooltip={limite.tooltip}
                data-pr-position="top"
              >
                {limite.nome} · {formatDataBr(limite.vencimento)}
              </span>
            ))}
            {ocultos > 0 && (
              <span className={`${styles.tag} ${styles.secondary}`} data-testid="limites-mais">
                +{ocultos}
              </span>
            )}
          </div>
          <button type="button" className={styles.verTodos} onClick={onVerTodos}>
            {INFO_EMBARCACAO.verTodos}
          </button>
          <Tooltip target={`.${styles.tag}[data-pr-tooltip]`} className={styles.tooltip} />
        </div>
      )}
    </section>
  );
}
